export default "__VITE_ASSET__adf5fa01__"